// extracted by mini-css-extract-plugin
export default {"title-card":"TitleCard_title-card__XsOAg","sub-title-card":"TitleCard_sub-title-card__XHa8j"};